import styled from '@emotion/styled';

import { COLORS3, FONT, MEDIA_QUERY } from '@zola/zola-ui/src/styles/emotion';

export const MobileBarContainer = styled.div`
  align-items: center;
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  max-width: 100%;
  width: 100%;

  & > div {
    width: 30%;
  }

  & > div:nth-of-type(2) {
    width: 40%;
  }

  & > div:last-of-type {
    align-items: center;
    display: flex;
    flex-flow: row;
    justify-content: flex-end;
  }

  ${MEDIA_QUERY.MOBILE} {
    & > div {
      width: 50%;
    }
    & > div:nth-of-type(2) {
      width: 50%;
    }
  }
`;

export const ResultsTxt = styled.p`
  ${FONT.textSizeRegular(FONT.SIZE.SMALL)}
  color: ${COLORS3.BLACK_100};
  font-family: ${FONT.FAMILY.SANS_SERIF};
  font-weight: ${FONT.WEIGHT.REGULAR};
  margin: 0;
`;
